import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Checkbox from '@mui/material/Checkbox';
import useDisplayLanguageHandleDropdown, {
  Option,
} from './display-language-handle-dropdown.hooks';
import { Box } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const ITEM_HEIGHT = 48;

type DisplayLanguageHandleDropdownProps = {
  options: Option[];
  value: Option[];
  onChange: (selectedOptions: Option[]) => void;
};

const DisplayLanguageHandleDropdown = ({
  options,
  value,
  onChange,
}: DisplayLanguageHandleDropdownProps) => {
  const {
    anchorEl,
    selectedOptions,
    handleClick,
    handleClose,
    handleCheckboxChange,
  } = useDisplayLanguageHandleDropdown({
    options,
    value,
    onChange,
  });

  return (
    <Box>
      <IconButton
        aria-label="more"
        id="multi-select-button"
        aria-controls={anchorEl ? 'multi-select-menu' : undefined}
        aria-expanded={anchorEl ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        data-testid="DisplayLanguageHandleDropdown.Button"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="multi-select-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
        // @ts-ignore
        MenuListProps={{ 'data-testid': 'DisplayLanguageHandle.MenuList' }}
      >
        {options.map(option => (
          <MenuItem
            key={option.id}
            onClick={() => handleCheckboxChange(option.id)}
            disabled={
              selectedOptions.includes(option.id) && selectedOptions.length < 2
            }
            data-testid="Dropdown.Option"
            sx={{ maxHeight: '40px' }}
          >
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              sx={{ mr: 0 }}
              checked={selectedOptions.includes(option.id)}
            />
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default DisplayLanguageHandleDropdown;
